import { baseApi } from '@api/baseApi';
import { GenericResult } from '@api/shared-types/GenericResult';
import { OrderComment, MaterialComment, SaveOrderComment, SaveMaterialComment } from '@api/order-reporting/types/commentTypes';



const commentApi = baseApi.injectEndpoints({
	overrideExisting: false,
	endpoints: (builder) => ({


		saveOrderComment: builder.mutation<GenericResult<OrderComment>,SaveOrderComment>({
			query: ({ unversionedSystemId, comment }) => ({
				url: 'OrderReporting/SaveOrderComment',
				method: 'POST',
				body: { unversionedSystemId, comment }
			}),
		}),


		saveMaterialComment: builder.mutation<GenericResult<MaterialComment>,SaveMaterialComment>({
			query: ({ unversionedOrderSystemId, materialSystemId, comment }) => ({
				url: 'OrderReporting/SaveOrderMaterialComment',
				method: 'POST',
				body: { unversionedOrderSystemId, materialSystemId, comment }
			}),
		}),
	}),
});


export const { 
	useSaveOrderCommentMutation,
	useSaveMaterialCommentMutation } = commentApi;